import { useEffect, useRef, useState } from 'react';
import './TimePicker.css';

interface TimePickerProps {
    readOnly?: boolean;
    selectedTime: string;
    onTimeSelected: (selectedTime: string) => void;
}

export const timeOptions = {
    TOUTE_HEURE: "Toute heure",
    JOUR: "Jour",
    SOIR: "Soir"
};

export const times = [timeOptions.TOUTE_HEURE, timeOptions.JOUR, timeOptions.SOIR];

const TimePicker: React.FC<TimePickerProps> = ({ readOnly = false, selectedTime, onTimeSelected }) => {

    const [dropdownIsOpen, setIsOpen] = useState<boolean>(false);
    const [_selectedTime, setSelectedTime] = useState<string>(selectedTime);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen(!dropdownIsOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        
            setSelectedTime(selectedTime);
   

    }, [selectedTime]);

    return <div className={["timepicker", "dropdown", _selectedTime == timeOptions.JOUR || _selectedTime == timeOptions.SOIR ? 'selected':''].join(' ')} ref={dropdownRef}>

        <div className="dd-flex">

            <span className="selected-item" onClick={readOnly ? undefined : () => { setIsOpen(false); onTimeSelected(_selectedTime); }}>{_selectedTime}</span>
            {!readOnly && <div className="dropdown-btn" onClick={() => toggleDropdown()}>▼</div>}
            {dropdownIsOpen && <div className="dropdown-content">
                {times.map(t =>
                    <div className="dropdown-item" onClick={readOnly ? undefined : () => { setIsOpen(false); onTimeSelected(t); }}>{t}</div>
                )}
            </div>}
        </div>
    </div>;

}

export default TimePicker;